import React, { Component } from "react";
// import { TwitterTimelineEmbed } from "react-twitter-embed";

import ContentBlock from "../../sections/ContentBlock/ContentBlock";
import Button from "../../components/Button/Button";
// import Banner from "../../sections/Banner/Banner";
// import IconBlock from "../../components/IconBlock/IconBlock";
import FadeInSection from "../../sections/FadeIn/FadeIn";
import ImageCard from "../../components/ImageCard/ImageCard";

import "./Home.css";

class Home extends Component {
  componentDidMount() {
    // window.addEventListener("scroll", this.detectScroll);
    const navbar = document.getElementsByClassName("Navbar")[0];
    navbar.classList.add("HomeNav");
  }
  componentWillUnmount() {
    // window.removeEventListener("scroll", this.detectScroll);
    const navbar = document.getElementsByClassName("Navbar")[0];
    navbar.classList.remove("HomeNav");
  }

  // handleScroll = () => {
  //   const headerImg = document.getElementById("homeHeaderImg");
  //   const d = window.scrollY / 2;
  //   headerImg.style.transform = `translateY(${d}px)`;
  // };
  // detectScroll = (e) => {
  //   requestAnimationFrame(this.handleScroll);
  // };
  render() {
    return (
      <div className="Home">
        <div className="headerVidContainer">
          <video className="headerVid" muted autoPlay loop playsInline>
            <source
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/video/hype/DTC-header-new.mp4"
              type="video/mp4"
            />
          </video>
          <div className="header">
            <h1>District Track Club</h1>
            <Button buttonType="White" size="md" to="/our-story">
              Our Story
            </Button>
          </div>
        </div>

        <section>
          <ContentBlock>
            <h3>Relentless. United. Strong</h3>
          </ContentBlock>

          <FadeInSection direction="bottom">
            <ContentBlock>
              <ImageCard
                img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/women_tom.jpg"
                img_alt="Women's Team and Tom"
                to="/our-team"
                buttonText="Read More"
              >
                <h4>Meet The Pros</h4>
                <p>
                  8 countries represented. Olympic and World Championship
                  Qualifiers. NCAA Champions and All-Americans. Meet team #DTC
                </p>
              </ImageCard>
              <ImageCard
                img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/gear.jpg"
                img_alt="Gear"
                to="https://www.districttrackgear.com/"
                buttonText="Read More"
              >
                <h4>Shop</h4>
                <p>
                  Represent District Track Club by shopping the latest release
                  of limited-run gear. Check out our online store.
                </p>
              </ImageCard>
              <ImageCard
                img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/men-running.jpg"
                img_alt="Edose Smiling"
                to="/training/overview"
                buttonText="Read More"
              >
                <h4>Train Like A Pro</h4>
                <p>
                  World-class performance is built on a foundation of training
                  principles to develop the mind and body. Train like a District
                  Track Club athlete by visiting the VPC.
                </p>
              </ImageCard>
            </ContentBlock>
          </FadeInSection>

          {/* <ContentBlock
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-1.jpg"
            img_alt="Edose smiling"
          >
            <FadeInSection direction="right">
              <h2>Cool DTC Program</h2>
              <p className="left">
                Esse aute reprehenderit consequat adipisicing quis ad proident
                Lorem. Ex consequat amet minim do. Eu aliqua mollit qui aute non
                elit duis ut velit do labore labore deserunt. Nulla minim anim
                aute sit magna culpa.
              </p>
              <Button buttonType="Info">Check It Out</Button>
            </FadeInSection>
          </ContentBlock>
          <ContentBlock
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-1.jpg"
            img_alt="Edose smiling"
            reverse={true}
          >
            <FadeInSection direction="left">
              <h2>Another Program</h2>
              <p className="left">
                Aliqua culpa do esse cupidatat consequat nostrud incididunt ut
                do et. Ullamco occaecat dolore qui voluptate mollit dolore
                incididunt exercitation in adipisicing proident do consectetur
                voluptate. Et sint deserunt enim minim. Cillum nulla aliquip
                magna Lorem nostrud dolore culpa enim cillum in cillum ex qui
                aliquip.
              </p>
              <Button buttonType="Primary">Check It Out</Button>
            </FadeInSection>
          </ContentBlock> */}
        </section>

        {/* <div className="TwitterContainer">
        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="DistrictTC"
          options={{ tweetLimit: "4" }}
        />
      </div> */}
      </div>
    );
  }
}

export default Home;
